import { marketingAnchors } from '../../../../app/_shared/marketing/landingContent';
import appStoreBadge from '../../assets/marketing/download-on-the-app-store-en-us.svg';
import googlePlayBadge from '../../assets/marketing/get-it-on-google-play-en.svg';
import {
  displayStoreBadges,
  hrefForStoreBadge,
  isExternalStoreUrl,
  type StoreBadgeKind,
} from '../../utils/storePlatform';
import './landingRef.css';

type Props = {
  className?: string;
  /** Hero aligns badges left; CTA/footer stay centered. */
  align?: 'center' | 'start';
};

const fallbackAnchor = `#${marketingAnchors.download}`;

function StoreBadge({ kind }: { kind: StoreBadgeKind }) {
  const href = hrefForStoreBadge(kind, fallbackAnchor);
  const external = isExternalStoreUrl(href);

  if (kind === 'ios') {
    return (
      <a
        className="ml-store ml-store--apple"
        href={href}
        target={external ? '_blank' : undefined}
        rel={external ? 'noopener noreferrer' : undefined}>
        <span className="ml-store__slot">
          <img
            className="ml-storeImg"
            src={appStoreBadge as unknown as string}
            alt="Download on the App Store"
            decoding="async"
          />
        </span>
      </a>
    );
  }

  return (
    <a
      className="ml-store ml-store--google"
      href={href}
      target={external ? '_blank' : undefined}
      rel={external ? 'noopener noreferrer' : undefined}>
      <span className="ml-store__slot">
        <img
          className="ml-storeImg"
          src={googlePlayBadge as unknown as string}
          alt="Get it on Google Play"
          decoding="async"
        />
      </span>
    </a>
  );
}

export function StoreBadgeRow({ className = '', align = 'center' }: Props) {
  const badges = displayStoreBadges();

  return (
    <div
      className={`ml-storeRow${align === 'start' ? ' ml-storeRow--start' : ''} ${className}`.trim()}>
      {badges.map((kind) => (
        <StoreBadge key={kind} kind={kind} />
      ))}
    </div>
  );
}
